import React, { FC, MouseEvent, useState } from 'react';
import Svg from 'svg-inline-react';
import { Appearance, Button } from '@src/components/Button';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { PasswordInput } from '@src/components/PasswordInput';
import { Error } from '@src/components/PasswordInput/interfaces/error.interface';
import { getPasswordErrorMessage } from '@src/util/validation';
import { trackEvent } from '@src/metrics';
import LogoSvg from '../logo.svg';
import { PasswordProps } from './props';
import './styles.scss';

export const Password: FC<PasswordProps> = ({
  newPassword,
  isUpdateRecruiterPasswordLoading,
  onUpdateNewPassword,
  onContinue,
  onBack,
}) => {
  const [errors, setErrors] = useState<Error | undefined>();

  const setNewPassword = (newPassword: string) => {
    setErrors(undefined);
    onUpdateNewPassword(newPassword);
  };

  const onContinueClick = async (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();

    const updatedErrors = getPasswordErrorMessage(newPassword);

    if (updatedErrors && Object.keys(updatedErrors).length > 0) {
      setErrors(updatedErrors);

      return;
    }

    await onContinue();

    trackEvent({
      context: MetricContext.FINISH_RECRUITER_PROFILE,
      interaction: MetricAction.UPDATE_RECRUITER_PROFILE,
    });
  };

  return (
    <div className="finish-recruiter-modal-password">
      <div className="finish-recruiter-modal-header">
        <div className="finish-recruiter-modal-header-title">
          Add your <br />
          <span>password</span> and
          <br />
          you are all set up!
        </div>
        <div className="finish-recruiter-modal-header-info">
          You are just <span>one step away</span>
          <br />
          to complete your account.
        </div>

        <Svg src={LogoSvg} />
      </div>

      <div className="finish-recruiter-modal-content">
        <PasswordInput errors={errors} onChange={setNewPassword} value={newPassword} />

        <div className="finish-recruiter-modal-password__actions">
          <Button
            className="finish-recruiter-modal-password__continue-button"
            isDisabled={isUpdateRecruiterPasswordLoading}
            onClick={onContinueClick}
          >
            Confirm
          </Button>

          <Button
            appearance={Appearance.SECONDARY}
            className="finish-recruiter-modal-password__continue-button"
            onClick={onBack}
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};
